import type { GetApiV1RefundsMyRequests200AllOf } from './getApiV1RefundsMyRequests200AllOf';
import type { GetApiV1RefundsMyRequests200AllOfThree } from './getApiV1RefundsMyRequests200AllOfThree';

export type GetApiV1RefundsMyRequests200 = GetApiV1RefundsMyRequests200AllOf & GetApiV1RefundsMyRequests200AllOfThree;
